import { appStore } from '@kaltura-ott/tvpil-shared';

import { contextStorage, intlStorage, overlayStorage, playerStorage } from 'components/widgets/Player/storages';
import { changeLocalState } from 'components/widgets/Player/utils/customEvents/customEventChangeLocalState';
import { getErrorContent } from 'components/widgets/Player/utils/getErrorContent/getErrorContent';
import { WARNING_ICON } from 'consts';
import { globalStorage } from 'services/globalStorage';
import networkService from 'services/networkService';
import { getWarningIcon } from 'utils';

import { COMPONENT_NAME } from '../../../../constants';
import { restorePlayerAfterError } from '../restorePlayerAfterError/restorePlayerAfterError';
import { tryToRestorePlayback } from '../tryToRestorePlayback/tryToRestorePlayback';

const defaultErrorMessage = 'Playback Error';

export async function criticalError(payload: any) {
  const {
    toastContext: { showToast, clearToast },
    errorContext,
    routerContext: router,
  } = contextStorage.getContext();
  const intl = intlStorage.getIntl();
  const { hideUI, player } = playerStorage.getPlayer();
  const { previousPlayerError, isNoConnectionErrorFired } = playerStorage;
  const isConnection = await networkService.isNetworkConnection();
  const code = payload.data?.data?.messages?.[0].code || payload.result?.error?.code || payload.code;
  const goBackResolve = router.location.key !== 'default' ? router.navigate : undefined;
  const warningIcon = `${appStore.staticAssetsUrl}${getWarningIcon(WARNING_ICON)}`;
  const errorContent = getErrorContent({
    isConnection,
    tryToRestorePlayback,
    handleRetry: restorePlayerAfterError,
    code,
    goBack: goBackResolve,
  });

  globalStorage.setPossiblePresentPlayer(true);

  // if Maxi player page
  if (hideUI) {
    playerStorage.clear();
    player.reset();

    showToast({
      title: intl.formatMessage({
        defaultMessage: defaultErrorMessage,
        id: `${COMPONENT_NAME}.playerErrorToastTitle`,
      }),
      icon: warningIcon,
    });
  } else {
    // avoid the multiple error timers calling
    if ((previousPlayerError && payload.severity) || isNoConnectionErrorFired) {
      return;
    }

    playerStorage.setPreviousPlayerError({ severity: payload.severity });

    clearToast();
    errorContext.clearError();
    changeLocalState({ isOpen: false });

    // Need to be added later in the Auto-recovery Mechanism for the Full Player
    // if (!isConnection) {
    //   retryConnection({ ...errorContent, playerErrorPayload: payload }, errorContext);
    //   return;
    // }

    errorContext.setError({ ...errorContent, playerErrorPayload: payload });
    overlayStorage.setShowErrorOverlay(true);
  }
}
